export default __webpack_public_path__ + "static/media/Renault.5ee57383.jpg";